import { render, staticRenderFns } from "./PeriodoConsumo.vue?vue&type=template&id=9afb680e&"
import script from "./PeriodoConsumo.vue?vue&type=script&lang=js&"
export * from "./PeriodoConsumo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports